import {RouterModule} from '@angular/router';
import {HomeComponent} from './home.component';
import {NgModule} from '@angular/core';
import {RoleFormComponent} from '../admin/roles/role-form/role-form.component';
import {UsersComponent} from '../admin/users/users.component';
import {UserListComponent} from '../admin/users/user-list/user-list.component';
import {UserFormComponent} from '../admin/users/user-form/user-form.component';
import {RoleListComponent} from '../admin/roles/role-list/role-list.component';
import {RolesComponent} from '../admin/roles/roles.component';
import {AccessGuard} from '../core/security/access.guard';
import {PersonalConfigComponent} from '../personal-config/personal-config.component';
import {DictamenesComponent} from '../fiscalia/component/dictamenes/dictamenes.component';
import {DictamenesListComponent} from '../fiscalia/component/dictamenes/dictamenes-list/dictamenes-list.component';
import {CategoriaListComponent} from '../fiscalia/component/dictamenes/categoria/categoria-list/categoria-list.component';
import {ProfileComponent} from '../profile/component/profile/profile.component';
import {CurriculumComponent} from '../profile/component/curriculum/curriculum.component';
import {HomeFiscaliaComponent} from '../fiscalia/component/home-fiscalia/home-fiscalia.component';
import {DictamenesFormComponent} from '../fiscalia/component/dictamenes/dictamenes-form/dictamenes-form.component';
import {AbogadoDetailResolver} from '../fiscalia/service/abogado-detail-resolver.service';
import {AbogadosProfilesComponent} from '../fiscalia/component/abogados-profiles/abogados-profiles.component';
import {AbogadosProfilesListComponent} from '../fiscalia/component/abogados-profiles/abogados-profiles-list/abogados-profiles-list.component';
import {TopicComponent} from '../fiscalia/component/forum/topic/topic.component';
import {TopicListComponent} from '../fiscalia/component/forum/topic/topic-list/topic-list/topic-list.component';
import {TopicFormComponent} from '../fiscalia/component/forum/topic/topic-form/topic-form.component';
import {PostComponent} from '../fiscalia/component/forum/post/post.component';
import {PostListComponent} from '../fiscalia/component/forum/post/post-list/post-list.component';
import {PostDetailComponent} from '../fiscalia/component/forum/post/post-destail/post-detail.component';
import {PostFormComponent} from '../fiscalia/component/forum/post/post-form/post-form.component';
import {UserRequestComponent} from '../fiscalia/component/user-request/user-request.component';
import {ChatComponent} from '../fiscalia/component/chat/chat.component';
import {DocumentCategoryListComponent} from '../fiscalia/component/repository/document-category/list/document-category-list.component';
import {DocumentCategoryComponent} from '../fiscalia/component/repository/document-category/document-category.component';
import {RepositoryComponent} from '../fiscalia/component/repository/repository.component';
import {DocumentCategoryFormComponent} from '../fiscalia/component/repository/document-category/form/document-category-form.component';
import {RepositoryExplorerComponent} from '../fiscalia/component/repository/explorer/explorer.component';
import {FormDataComponent} from 'app/forms/components/form-data/form-data.component';
import {FormListComponent} from '../forms/components/form-list/form-list.component';
import {FormEditorComponent} from '../forms/components/form-editor/form-editor.component';
import {FormDataListComponent} from '../forms/components/form-data-list/form-data-list.component';
import {ReplyFormComponent} from '../fiscalia/component/forum/post/reply-form/reply-form.component';
import {FormDataResolveService} from '../forms/services/form-data-resolve.service';
import {MinistriesComponent} from '../fiscalia/component/ministries/ministries.component';
import {MinistryListComponent} from '../fiscalia/component/ministries/ministry-list/ministry-list.component';
import {MinistryFormComponent} from '../fiscalia/component/ministries/ministry-form/ministry-form.component';
import {AbogadosProfilesDetailComponent} from 'app/fiscalia/component/abogados-profiles/abogados-profiles-detail/abogados-profiles-detail.component';
import {ReportErrorsComponent} from '../fiscalia/component/report-errors/report-errors.component';
import {FormViewDetailComponent} from '../form-views/components/form-view-detail/form-view-detail.component';
import { FormViewListComponent } from 'app/form-views/components/form-view-list/form-view-list.component';
import { FormViewDataListComponent } from 'app/form-views/components/data/form-view-data-list/form-view-data-list.component';
import { FormViewDataDetailComponent } from 'app/form-views/components/data/form-view-data-detail/form-view-data-detail.component';
import {FormViewDataEditorComponent} from '../form-views/components/data/form-view-data-editor/form-view-data-editor.component';

/**
 * Created by Lauta on 21/2/2017.
 */

const homeRoutes = [ 
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AccessGuard],
        canActivateChild: [AccessGuard],
        children: [
            {
                path: '',
                component: HomeFiscaliaComponent
            },
            {
                path: 'role',
                component: RolesComponent,
                children: [
                    {
                        path: '',
                        component: RoleListComponent
                    },
                    {
                        path: ':id',
                        component: RoleFormComponent
                    }
                ]
            },
            {
                path: 'users',
                component: UsersComponent,
                children: [
                    {
                        path: '',
                        component: UserListComponent
                    },
                    {
                        path: ':id',
                        component: UserFormComponent
                    }
                ]
            },
            {
                path: 'ministry',
                component: MinistriesComponent,
                children: [
                    {
                        path: '',
                        component: MinistryListComponent
                    },
                    {
                        path: ':id',
                        component: MinistryFormComponent
                    }
                ]
            },
            {
                path: 'user-requests',
                component: UserRequestComponent
            },
            {
                path: 'dictamenes',
                component: DictamenesComponent,
                children: [
                    {
                        path: '',
                        component: DictamenesListComponent
                    },
                    {
                        path: 'categoria',
                        component: CategoriaListComponent
                    },
                    {
                        path: ':id',
                        component: DictamenesFormComponent
                    }
                ]
            },
            {
                path: 'abogados-profiles',
                component: AbogadosProfilesComponent,
                children: [
                    {
                        path: '',
                        component: AbogadosProfilesListComponent
                    },
                    {
                        path: ':id',
                        component: AbogadosProfilesDetailComponent,
                        resolve: {abogado: AbogadoDetailResolver}
                    }
                ]
            },
            {
                path: 'topic',
                component: TopicComponent,
                children: [
                    {
                        path: '',
                        component: TopicListComponent
                    },
                    {
                        path: ':id',
                        component: TopicFormComponent
                    }
                ]
            },
            {
                path: 'post',
                component: PostComponent,
                children: [
                    {
                        path: '',
                        component: PostListComponent
                    },
                    {
                        path: ':id/edit',
                        component: PostFormComponent
                    },
                    {
                        path: ':id',
                        component: PostDetailComponent
                    },
                    {
                        path: ':postId/reply/:id',
                        component: ReplyFormComponent
                    }
                ]
            },
            {
                path: 'profiles',
                component: ProfileComponent
            },
            {
                path: 'settings',
                component: PersonalConfigComponent
            },
            {
                path: 'curriculumVitaes',
                component: CurriculumComponent
            },
            {
                path: 'chat',
                component: ChatComponent
            },
            {
                path: 'repository',
                component: RepositoryComponent,
                children: [
                    {
                        path: 'category',
                        component: DocumentCategoryComponent,
                        children: [
                            {
                                path: '',
                                component: DocumentCategoryListComponent
                            },
                            {
                                path: ':id',
                                component: DocumentCategoryFormComponent
                            }
                        ]
                    },
                    {
                        path: '',
                        component: RepositoryExplorerComponent
                    }
                ]
            },
            {
                path: 'forms',
                children: [
                    {
                        path: '',
                        component: FormListComponent
                    },
                    {
                        path: 'new',
                        component: FormEditorComponent
                    },
                    {
                        path: 'new/:template',
                        component: FormEditorComponent
                    },
                    {
                        path: 'upgrade/:version',
                        component: FormEditorComponent
                    },
                    {
                        path: 'data',
                        component: FormDataListComponent
                    },
                    {
                        path: ':id',
                        component: FormEditorComponent
                    },
                    {
                        path: 'view/:formId/:mode',
                        component: FormDataComponent
                    },
                    {
                        path: 'data',
                        children: [
                            {
                                path: 'new/:formId',
                                component: FormDataComponent
                            },
                            {
                                path: ':dataId',
                                component: FormDataComponent
                            },
                            {
                                path: ':dataId/:mode',
                                component: FormDataComponent
                            }
                        ]
                    }
                ]
            },
            {
                path: 'report-errors',
                component: ReportErrorsComponent,
            },
            {
                path: "view",
                children: [
                    {
                        path: '',
                        component: FormViewListComponent
                    },
                    {
                        path: 'detail/:id',
                        component: FormViewDetailComponent
                    },
                    {
                        path: 'filled',
                        component: FormViewDataListComponent
                    },
                    {
                        path: 'filled/detail/:id',
                        component: FormViewDataDetailComponent
                    },
                    {
                        path: 'update/:id',
                        component: FormViewDataEditorComponent
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(homeRoutes)],
    exports: [RouterModule],
    providers: [AccessGuard, AbogadoDetailResolver, FormDataResolveService]
})
export class HomeRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/home/routing.module.ts